import { render, staticRenderFns } from "./acord.vue?vue&type=template&id=22ecd39e&scoped=true&"
import script from "./acord.vue?vue&type=script&lang=ts&"
export * from "./acord.vue?vue&type=script&lang=ts&"
import style0 from "./acord.vue?vue&type=style&index=0&id=22ecd39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ecd39e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
